import { computeTime } from "fieldpro-tools";

export const getAbsoluteDateFromDate = (date: Date) => {
  return [
    {
      period: "YEAR",
      value: date.getFullYear(),
    },
    {
      period: "MONTH",
      value: date.getMonth(),
    },
    {
      period: "DAY",
      value: date.getDay(),
    },
    {
      period: "HOUR",
      value: date.getHours(),
    },
  ];
};

export const computeTerminaisonTime = (
  now: Date,
  absolute: Array<{ value: number; period: string }>,
  relative: Array<{ value: number; period: string }>,
): string => {
  const transposedDate = computeTime(now, absolute, relative, true);
  const localDate = transposedDate.toLocaleString(
    window._env_?.NODE_ENV === "test" ? "en-US" : undefined,
  );
  return localDate;
};

export const clockToDate = (clock?: string): Date | undefined => {
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(clock ?? "");
  if (!match) return undefined;
  const date = new Date();
  date.setHours(Number(match[1]), Number(match[2]), 0, 0);
  return date;
};
export const dateToClock = (date: Date | null): string => {
  if (!date || Number.isNaN(date.getTime())) return "";
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const getWeekNb = (date: Date) => {
  //find the year of the entered date
  const oneJan = new Date(date.getFullYear(), 0, 1);
  // calculating number of days in given year before the given date
  const numberOfDays = Math.floor(
    (date.getTime() - oneJan.getTime()) / (24 * 60 * 60 * 1000),
  );
  // adding 1 since to current date and returns value starting from 0
  const result = Math.ceil((date.getDay() + 1 + numberOfDays) / 7);
  return result;
};

export const getBusinessWindowOrderError = (
  attributes: { start_time?: string; end_time?: string },
  orderMessage: string,
): { end_time: string } | undefined => {
  if (
    attributes.start_time &&
    attributes.end_time &&
    attributes.start_time >= attributes.end_time
  ) {
    return { end_time: orderMessage };
  }
  return undefined;
};
